<template>
<div>
        <div class="head">
        <div class="headbar">
            <div class="container">
                <div class="head-lt">
                    <a>欢迎回来到沃德珠宝！ </a>
                </div>
                <div class="head-md webCSS">
                    <marquee direction="left">温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
                        1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
                        2、实际到货后， 货品“地点”将变更为”HK”。
                        3、下单即视为可以接受货品7个工作日之内到港。
                        4、货品质量与香港现货库存一致。</marquee>
                </div>
            </div>
        </div>
        <div class="head-nav">
            <div class="header">
                <div class="header-lt">
                    <div class="logo">
                        <a href="">
                            <img src="/static/img/img/logo.png"/></a>
                    </div>
                </div>
                <div class="header-ce">
                    <div class="nav">
                        <ul>
                            <li @click="goPage('Home')">首页</li>
                            <li @click="goPage('DiamondSearch')">GIA裸钻</li>
                            <li @click="goPage('MyCar')">我的购物车</li>
                            <li @click="goPage('MyOrder')">我的订单</li>
                            <li @click="goPage('Calculator', true)">计算器</li>
                            <li @click="goPage('FeedBack', true)">问题反馈</li>
                            <li @click="goPage('ChangePass')">修改密码</li>
                            <li @click="loginOut">注销登录</li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Slide class="Home-banner swiper-container" ref="swiperContainer">
         <div class="swiper-wrapper" id="swiper-wrapper">
            <div class="swiper-slide">
                <img src="/static/img/img/banner1.jpg" />
            </div>
            <div class="swiper-slide">
                <img src="/static/img/img/banner2.jpg"/>
            </div>
            <div class="swiper-slide">
                <img src="/static/img/img/banner3.jpg" />
            </div>
        </div>
        <div class="swiper-pagination"></div>
    </Slide>
    <div class="all-nav">
        <ul class="all-nav-ul">
            <li @click="goPage('DiamondSearch')">
                    <img src="/static/img/img/wdia.png" />
                    <p class="ch_p">GIA裸钻查询</p>
                    <p class="en_p">GIA Naked Drill</p>
            </li>
            <li class="isguest" @click="goPage('MyCar')">
                    <img src="/static/img/img/sdia.png"
                        tppabs="https://wd.echao.com//static/img/img/sdia.png" />
                    <p class="ch_p">购物车 </p>
                    <p class="en_p">Shopping Cart</p>
            </li>
            <li class="isguest" @click="goPage('MyOrder')">
                    <img src="/static/img/img/odia.png"
                        tppabs="https://wd.echao.com//static/img/img/odia.png" />
                    <p class="ch_p">我的订单</p>
                    <p class="en_p">My Orders</p>
             </li>
            <li @click="goPage('Calculator', true)">
                <img src="/static/img/img/calculator.png"
                    tppabs="https://wd.echao.com//static/img/img/pdia.png" />
                <p class="ch_p">国际报价</p>
                <p class="en_p">International Quotation Of Price</p>
            </li>
            <li  @click="goPage('FeedBack', true)">
                <img src="/static/img/img/pdia.png"/>
                <p class="ch_p">问题反馈</p>
                <p class="en_p">Problem Feedback </p>
            </li>
            <li class="mobileCSS isguest"><a class="notice">
                    <img src="/static/img/img/odia.png"/>
                    <p class="ch_p">通知查看</p>
                    <p class="en_p">Notice Board</p>
                </a></li>
            <li class="mobileCSS isguest"><a href="index.html"
                    class="isguest">
                    <img src="/static/img/img/edia.png" />
                    <p class="ch_p">安全退出</p>
                    <p class="en_p">Logging Out</p>
                </a></li>
        </ul>
    </div>
    <div class="board" style="display: none">
        <div class='board_title'><i class='fa fa-file-audio-o' aria-hidden='true'></i>公告栏<span> Notice Board</span> <a
                class='board_close'></a></div>
        <p>温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净

            1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
            2、实际到货后， 货品“地点”将变更为”HK”。
            3、下单即视为可以接受货品7个工作日之内到港。
            4、货品质量与香港现货库存一致。</p>
    </div>
    <div class="modelBox" style="display:none;">
        <div class="model">
            <img src=""  />
            <p class="timeer">
                <span>4</span>&nbsp;S
            </p>
            <i class="closed">x</i>
        </div>
    </div>
    </div>
</template>
<script>
    import Core from '@/until/core'
    import Slide from '@/public/Slide'
    import Swiper from 'swiper'
    export default {
        name: 'Home',
        data () {
            return {
                options: {},
                database: {
                    username: '',
                    password: ''
                },
                hasSwiper: false
            }
        },
        components: {
            Slide
        },
         watch: {
            bannerList (arr) {
                if (arr.length && !this.options.hasSwiper) {
                    this.options.hasSwiper = true
                    setTimeout(() => {
                        this.$refs.swiperContainer && this.$refs.swiperContainer.initSlide()
                    }, 300)
                }
            }
        },
        computed: {
            uid () {
                return this.$route.params.Uid
            },
            ossPath () {
                return this.$store.state.ossPath
            },
            webConfig () {
                const config = this.$store.state.config
                document.title = config.web_custommall_diamond_title || 'GIA裸钻'
                return config
            },
            notice () {
                if (this.webConfig.web_custommall_diamond_notice) {
                    return this.webConfig.web_custommall_diamond_notice
                }
                return ''
            },
            bannerList () {
                const data = JSON.parse(this.webConfig.web_custommall_diamond_figure || '[]')
                const arr = []
                if (data.length && this.ossPath) {
                    for (let item of data) {
                        if (item.path && item.path.indexOf('#OSS_OBJECT_URL') === 0) {
                            arr.push(this.ossPath + item.path.replace('#OSS_OBJECT_URL', ''))
                        }
                    }
                }
                return arr
            },
            staffData () {
                return this.$store.state.staffData || {}
            }
        },
        filters: {},
        methods: {
            goPage (name, bool) {
                const that = this
                if (bool) {
                    return Core.goNext(name, that.$route.params)
                }
                Core.loginExist().then(res => {
                    if (res) {
                        return Core.goNext(name, that.$route.params)
                    }
                    Core.goNext('StaffLogin', that.$route.params)
                })
            },
            loginOut () {
                Core.onRemoveToken()
                Core.goNext('StaffLogin', this.$route.params, true)
            },
            initSlide () {
                if (!this.$refs.swiperContainer) {
                    return
                }
                if (this.autoplay) {
                    this.slide = new Swiper('.swiper-container', {
                        pagination: '.swiper-pagination',
                        paginationClickable: true,
                        loop: true,
                        centeredSlides: true,
                        autoplay: this.slideTime,
                        autoplayDisableOnInteraction: false
                    })
                } else {
                    this.slide = new Swiper('.swiper-container', {
                        pagination: '.swiper-pagination',
                        paginationClickable: true,
                        loop: true,
                        centeredSlides: true
                    })
                }
            }
        },
        mounted () {
            if (this.bannerList.length) {
                this.options.hasSwiper = true
                setTimeout(() => {
                    this.$refs.swiperContainer && this.$refs.swiperContainer.initSlide()
                }, 300)
            }
            if (Core.hasToken()) {
                Core('Api/User/Detailed').then(body => {
                    if (body.data && !body.data.error_code && body.data.data) {
                        if (parseInt(this.$route.params.Uid) === 19) {
                            let mac = localStorage.getItem('mac')
                            if (parseInt(body.data.data.equipment_count || 0) > 1 && !mac) {
                                // 跳转选择店铺
                                Core.goNext('SelectShop', this.$route.params)
                            } else if (parseInt(body.data.data.equipment_count || 0) === 1 && !mac) {
                                let mac = JSON.parse(body.data.data.equipment.mac || '[]')
                                localStorage.setItem('mac', mac[0] || '')
                            }
                        }
                    }
                })
            }
        }
    }
</script>
<style scoped>
@import '../../node_modules/swiper/dist/css/swiper.min.css';
@import '../../static/css/yellow.css';
@import '../../static/css/font-awesome.css';
.nav{ height: 90px; }
.header-ce{ width:1000px; }
.header-ce ul li{ float: left; line-height: 90px; width:100px; text-align: center;}
.Home-banner{ width: 100%; height: 600px; overflow: hidden; background-color: #fff; }
.btn-hk {
            color: #fff;
            padding: 8px 16px;
            line-height: 100px;
            background: #F268A3;
            border-radius: 2px;
            font-size: 13px;
        }

        .modelBox {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: rgba(0, 0, 0, .65);
            overflow: hidden;
            z-index: 999;
        }

        .model {
            position: absolute;
            width: 1000px;
            height: 500px;
            margin: 0 auto;
            left: 0;
            right: 0;
            top: calc(50% - 350px);
            z-index: 9999;
            text-align: center;
            padding: 50px 0;
        }

        .closed {
            display: block;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            position: absolute;
            right: 150px;
            top: 120px;
            text-align: center;
            line-height: 22px;
            background: #e0b12f;
            color: #fff;
            font-size: 14px;
            cursor: pointer;

        }

        .timeer {
            text-align: center;
            position: absolute;
            bottom: 0;
            width: 100px;
            margin: auto;
            left: 0;
            right: 0;
            line-height: 40px;
            font-size: 14px;
            color: #FFEB3B;
            font-size: 30px;
            border-radius: 5px;
        }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue